import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getImportSyncedEntitiesData} from 'src/openapi/admin/apis/ImportSyncedEntitiesApi';
import {useAppDispatch} from 'src/store/hooks';

import type {CrmType} from 'src/openapi/admin/models/CrmType';

type Props = {
    accountId: number,
    targetLicenseId: number,
    crmType: CrmType,
};
export const useImportSyncedEntities = ({accountId, crmType, targetLicenseId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        getImportSyncedEntitiesData({
            accountId,
            targetLicenseId,
            crmType,
        }, {signal}),
    ), [accountId, crmType, targetLicenseId, apiDispatch]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
